import React from 'react'
import { Link } from 'react-router-dom';
import { checkPermission } from '../../../helpers/commonFunctions';

// Common header for the three brand level ERP reports.
// tab: 'sales' | 'payments' | 'commissions'
const BrandERPReportHeader = ({ tab: Tab }) => {

    if (!checkPermission('store_brand_erp_reports', 'view')) {
        return null;
    }

    return (
        <ul className='d-flex setting submenu-list border-bottom mb-0 p-0'>
            <li className={Tab === 'sales' ? 'active' : ''}>
                <Link to={`/company/brand-report/erp_sales/list/${1}`} className="btn">
                    Sales
                </Link>
            </li>
            <li className={Tab === 'payments' ? 'active' : ''}>
                <Link to={`/company/brand-report/erp_payments/list/${1}`} className="btn">
                    Payments
                </Link>
            </li>
            <li className={Tab === 'commissions' ? 'active' : ''}>
                <Link to={`/company/brand-report/erp_commissions/list/${1}`} className="btn">
                    Commissions
                </Link>
            </li>
        </ul>
    );
}

export default BrandERPReportHeader
